import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { IndustryService } from '../../services/industry.service';
import { DEFAULT_INDUSTRY_UI_CONFIG, INDUSTRY_UI_CONFIGS, } from './industry-ui-config-data';
import { FooterActionKey, IndustryUiConfig } from './industry-ui.model';
import { isDenominationEnabledFor } from '../config/feature-flags';


@Injectable({
    providedIn: 'root',
})
export class IndustryUiConfigService {

    private configSubject = new BehaviorSubject<IndustryUiConfig>(DEFAULT_INDUSTRY_UI_CONFIG,);

    public readonly config$ = this.configSubject.asObservable();

    constructor(private authService: AuthService, private industryService: IndustryService) {
        // Handles page refresh / already-logged-in-on-load.
        this.resolveFromCurrentUser();

        // FIX: Subscribe to IndustryService.industry$ directly.
        // This is the most reliable trigger because IndustryService.setIndustry()
        // is called directly inside authService.login() tap on every login — guaranteed to fire.
        // OLD approach (kept for reference — subscription to authService.currentUser was unreliable
        // because setUserValue() was replacing the BehaviorSubject, orphaning subscribers):
        // this.authService.currentUser.subscribe(() => this.resolveFromCurrentUser());
        this.industryService.industry$.subscribe((industryId) => {
            this.resolveFromId(industryId);
        });
    }


    get config(): IndustryUiConfig {
        return this.configSubject.value;
    }

    isFooterActionVisible(key: FooterActionKey): boolean {
        return this.config.footerActions.some((action) => action.key === key);
    }

    private resolveFromCurrentUser(): void {
        const industryId: any = this.authService.currentUserValue?.industry;
        this.resolveFromId(industryId);
    }

    // FIX: Resolve config from a direct numeric industry ID (e.g., 14 = Mobile, 4 = Retail).
    // Coerces to number to handle cases where the API sends industry as a string (e.g., "14").
    private resolveFromId(industryId: any): void {
        const id = industryId != null ? Number(industryId) : null;
        const resolved =
            id != null && !isNaN(id) && INDUSTRY_UI_CONFIGS[id]
                ? INDUSTRY_UI_CONFIGS[id]
                : DEFAULT_INDUSTRY_UI_CONFIG;

        // Feature flag: drop the Denomination footer button where it's turned off
        // (copy, so the shared config constant is never mutated)
        const config = isDenominationEnabledFor(id)
            ? resolved
            : { ...resolved, footerActions: resolved.footerActions.filter((a) => a.key !== 'denomination') };
        this.configSubject.next(config);
    }

}